import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/cn';
import { UNPRICED_HINT_KEY, UNPRICED_KEY } from '@/lib/allocation/price';

/**
 * «No disponible» — an amount operator-bff could not price (no price card, commercial-
 * contract D17). Rendered wherever a hotel price would be; never a 0, never the cost.
 */
export function Unpriced({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <span className={cn('text-muted-foreground', className)} title={t(UNPRICED_HINT_KEY)} data-testid="unpriced">
      {t(UNPRICED_KEY)}
    </span>
  );
}
